import {Component, OnDestroy} from '@angular/core';
import {Store} from '@ngxs/store';
import {ActivatedRoute} from '@angular/router';

/*
 * Component to be used in routing modules. Dispatches an action when destroyed.
 * {
 *      path: 'offer/:offerId',
 *      data: {
 *          destroyerAction: SalesCpiAction.ClearSalesForm,
 *          destroyerActionPayload: {foo: 'bar'},
 *      },
 *      component: DestroyerComponent,
 * }
 * 'Now I am become Death, the destroyer of components'
 */

@Component({
    selector: 'app-destroyer',
    template: '<router-outlet></router-outlet>',
})
export class DestroyerComponent implements OnDestroy {
    constructor(private route: ActivatedRoute, private store: Store) {}

    ngOnDestroy() {
        const {destroyerAction = null, destroyerActionPayload = null} = this.route?.snapshot?.data;
        if (typeof destroyerAction === 'function') {
            const action = destroyerActionPayload !== null ? new destroyerAction(destroyerActionPayload) : new destroyerAction();
            if (action) {
                this.store.dispatch(action);
            }
        }
    }
}
